module.exports = __webpack_public_path__ + "static/media/icon-settings.d15941a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-settings.svg
// module id = 1267
// module chunks = 19